/*
 * Copyright (c) 2022-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { useCallback } from 'preact/hooks';

import { useWidgetContext } from '../contexts';
import { FieldElement } from '../types';

export const useOnChange = (uischema: FieldElement) => {
  const { inputMask, options: { inputMeta: { name } } } = uischema;
  const { setData } = useWidgetContext();

  return useCallback((value: string | boolean | number) => {
    let maskedValue: string;
    if (inputMask && typeof value === 'string') {
      maskedValue = value.replace(inputMask.pattern, inputMask.replacement);
    }
    setData((data) => ({
      ...data,
      [name]: maskedValue || value,
    }));
  }, [setData, name, inputMask]);
};
